export default {
  adminUserInfo:{},//后台用户信息
}
